import { render, staticRenderFns } from "./RalSwatch.vue?vue&type=template&id=f1aa2a32&scoped=true"
import script from "./RalSwatch.vue?vue&type=script&lang=js"
export * from "./RalSwatch.vue?vue&type=script&lang=js"
import style0 from "./RalSwatch.vue?vue&type=style&index=0&id=f1aa2a32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1aa2a32",
  null
  
)

export default component.exports